import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { DisplayService } from '../service/display.service';
import { FactorselectionService } from '../service/factorselection.service';
import { getIconForTag, getTitleForTag } from "../shared/credential-metadata-tag-utils";
import {Subscription} from "rxjs";
import { faBriefcase, faUser } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-multi-credentials',
  templateUrl: './multi-credentials.component.html'
})
export class MultiCredentialsComponent implements OnInit, OnDestroy {

  @Input() errorMsg: string;
  @Input() credentialOptions: any[];
  @Input() buttonLabel: string;
  @Output() selectedCredential = new EventEmitter();
  credential: any;
  factorSelection: boolean = false
  clicked: boolean = false;
  ready: boolean;
  errorDiv: any;
  pageSubs: Subscription[] = new Array<Subscription>();
  briefcaseIcon = faBriefcase;
  personalIcon = faUser;
  public getIconForTag: (tag: string) => IconDefinition = getIconForTag;
  public getTitleForTag: (tag: string) => string = getTitleForTag;

  constructor(
    private readonly factorselectionService: FactorselectionService, 
    private readonly router: Router, 
    private readonly displayService: DisplayService
  ) { }

  ngOnInit(): void {
    this.factorSelection = this.displayService.factorSelection;
    this.handleDefaultSelection();
    this.ready = true;
  }

  handleDefaultSelection() {
    if(this.credentialOptions) {
      for (let cred of this.credentialOptions) {
        if (cred.default) {
          this.credential = cred;
          break;
        }
      }
    }
  }

  onSelect(cred) {
    this.credential = cred;
  }

  onSendCode() {
    this.clicked = true;
    this.selectedCredential.emit(this.credential);
    this.displayService.focusNthField(0, 200);
  }

  factorSelect() {
    this.ready = false;
    this.pageSubs.push(
      this.factorselectionService.chooseAnother()
    );
  }

  ngOnDestroy() {
    this.pageSubs.forEach((sub) => {
      sub?.unsubscribe();
    });
  }

}
